import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import 'leaflet/dist/leaflet.css'
Vue.use(VueClipboard)
Vue.config.productionTip = false

new Vue({
  store,
  vuetify,
  router,
  created() {
    this.$store.dispatch('showLoader')
    this.$store.dispatch('initHeaders')
    this.$store.dispatch('hideLoader')
  },
  render: h => h(App)
}).$mount('#app')
